import { U21Button } from 'app/shared/u21-ui/components';
import {
  toggleLocalTableConfigSidebar,
  toggleTableConfigSidebar,
} from 'app/modules/sidebar/slice';
import { TableConfigType } from 'app/shared/CustomConfig/models';
import { LocalTableConfigType } from 'app/modules/localTableSettings/models';
import { IconLayoutColumns } from '@u21/tabler-icons';
import { useDispatch } from 'react-redux';

type Props =
  | {
      tableConfigType: TableConfigType;
      local?: false;
    }
  | {
      tableConfigType: LocalTableConfigType;
      local: true;
    };

export const ChooseColumnsButton = (props: Props) => {
  const { local, tableConfigType } = props;
  const dispatch = useDispatch();
  return (
    <U21Button
      onClick={(e) => {
        const coordinates = { x: e.clientX, y: e.clientY };
        if (local) {
          dispatch(
            toggleLocalTableConfigSidebar({
              coordinates,
              tableConfigType,
            }),
          );
        } else {
          dispatch(
            toggleTableConfigSidebar({
              coordinates,
              tableConfigType,
            }),
          );
        }
      }}
      startIcon={<IconLayoutColumns />}
    >
      Choose Columns
    </U21Button>
  );
};
